import React from 'react';

const FilterPanel = ({ filters, setFilters }) => {
  const roles = ['Developer', 'Publisher', 'Investor', 'Mentor'];
  const platforms = ['PC', 'Mobile', 'Console', 'VR/AR', 'Web', 'Arcade'];
  const genres = ['Action', 'Adventure', 'RPG', 'Strategy', 'Simulation', 'Puzzle', 'Horror', 'Racing', 'Sports', 'Casual'];

  const handleArrayFilter = (filterName, value) => {
    const currentValues = filters[filterName] || [];
    const newValues = currentValues.includes(value)
      ? currentValues.filter(v => v !== value)
      : [...currentValues, value];
    
    setFilters(prev => ({
      ...prev,
      [filterName]: newValues
    }));
  };

  const clearFilters = () => {
    setFilters({
      role: '',
      platforms: [],
      genres: []
    });
  };

  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center">
        <h3 className="text-sm font-medium text-gray-900">Filters</h3>
        <button
          onClick={clearFilters}
          className="text-xs text-indigo-600 hover:text-indigo-700"
        >
          Clear All
        </button>
      </div>

      {/* Role Filter */}
      <div>
        <label className="block text-xs font-medium text-gray-700 mb-2">Role</label>
        <div className="flex flex-wrap gap-2">
          {roles.map(role => (
            <button
              key={role}
              onClick={() => setFilters(prev => ({ ...prev, role: prev.role === role ? '' : role }))}
              className={`px-3 py-1 text-xs rounded-full border transition-colors ${
                filters.role === role
                  ? 'border-indigo-500 bg-indigo-50 text-indigo-700'
                  : 'border-gray-300 text-gray-600 hover:border-gray-400'
              }`}
            >
              {role}
            </button>
          ))}
        </div>
      </div>

      {/* Platforms Filter */}
      <div>
        <label className="block text-xs font-medium text-gray-700 mb-2">Platforms</label>
        <div className="flex flex-wrap gap-2">
          {platforms.map(platform => (
            <button
              key={platform}
              onClick={() => handleArrayFilter('platforms', platform)}
              className={`px-3 py-1 text-xs rounded-full border transition-colors ${
                (filters.platforms || []).includes(platform)
                  ? 'border-blue-500 bg-blue-50 text-blue-700'
                  : 'border-gray-300 text-gray-600 hover:border-gray-400'
              }`}
            >
              {platform}
            </button>
          ))}
        </div>
      </div>

      {/* Genres Filter */}
      <div>
        <label className="block text-xs font-medium text-gray-700 mb-2">Genres</label>
        <div className="flex flex-wrap gap-2">
          {genres.map(genre => (
            <button
              key={genre}
              onClick={() => handleArrayFilter('genres', genre)}
              className={`px-3 py-1 text-xs rounded-full border transition-colors ${
                (filters.genres || []).includes(genre)
                  ? 'border-purple-500 bg-purple-50 text-purple-700'
                  : 'border-gray-300 text-gray-600 hover:border-gray-400'
              }`}
            >
              {genre}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FilterPanel;